import { useEffect } from 'react';
import { reduxForm, FormSection, Form, change } from 'redux-form';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Tarrificator } from '../tarifficators/tarifficator';
import { TariffFormMain } from './tariff-form-main';
import { TariffData, FormHeader, SaveButton } from './tariff-form-old.styled';
import { validate } from '../validation';

const TariffForm = (props) => {
  const {
    info,
    onSubmit,
    onSubmitClick,
    tarrificatorParams,
    invalid,
    disabled,
    categories,
    vehicleClasses,
    // showUpdateMessage,
    // showMessageAfterAdd,
    handleSubmit,
    getActions,
    reset,
    newTimeFrom,
    dispatch,
    form,
    ...rest
  } = props;

  const { t } = useTranslation();

  // set actions
  useEffect(() => {
    getActions && getActions({ reset });
  }, []);

  // change time from
  useEffect(() => {
    dispatch(change('TariffForm', 'time_from', newTimeFrom));
  }, [newTimeFrom]);

  // console.log('newTimeFrom', newTimeFrom);

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <TariffData>
        <FormHeader>{t('form.Данные тарифа')}</FormHeader>
        <TariffFormMain categories={categories} vehicleClasses={vehicleClasses} type={info.type} initialValue={info} disabled={disabled} {...rest} />
        {/* {showUpdateMessage && <UpdateMessageBox>{t('form.Новый тариф создан')}</UpdateMessageBox>} */}
        {/* {showMessageAfterAdd && <UpdateMessageBox>{t('form.Новый тариф создан')}</UpdateMessageBox>} */}
        {/* <UpdateMessageBox>{t('form.Новый тариф создан')}</UpdateMessageBox> */}
      </TariffData>

      <FormSection name="zones">
        <Tarrificator {...tarrificatorParams} />
      </FormSection>
      <SaveButton /*disabled={invalid}*/ invisible={disabled} onClick={onSubmitClick} />
    </Form>
  );
};

TariffForm.propTypes = {
  onSubmit: PropTypes.any.isRequired,
  onSubmitClick: PropTypes.any.isRequired,
  initialValues: PropTypes.any.isRequired,
  tarrificatorParams: PropTypes.any.isRequired,
  invalid: PropTypes.any,
  disabled: PropTypes.any,
  categories: PropTypes.any.isRequired,
  vehicleClasses: PropTypes.any.isRequired,
  handleSubmit: PropTypes.any.isRequired,
  // showUpdateMessage: PropTypes.bool,
  // showMessageAfterAdd: PropTypes.bool,
  info: PropTypes.any,
};

export default reduxForm({
  form: 'TariffForm',
  //initialValues,
  validate,
  // shouldError: (params) => {
  //   console.log("🚀 ~ params:", params)
  //   return true;
  // },
  // validateOn: 'change',
  // enableReinitialize: true,
  // keepDirtyOnReinitialize: false,
})(TariffForm);
